import { type ImageElement } from '..';
import { getGenericBounds } from '../../../lib/bound';
import { type GenericShape } from '../../../lib/shapes';
import { getBoundsShape } from '../../poly/utils/shape';

export const getImageShape = (element: ImageElement): GenericShape => {
  const bounds = getGenericBounds(element);

  return getBoundsShape(bounds, element.x, element.y, element.angle);
};
